<template>
  <footer class="application-footer">
          <div class="application-footer__wrapper">
            <div
              class="application-footer__container"
              :class="{hasPolicy: policyHref}"
            >
              <a :href="clientLink"  target="_blank" class="application-footer-logo">
                <picture>
                  <source id="s3" :srcset="logoSrcDefault" type="image/svg">
                  <img :src="logoSrc" alt="" onerror="this.src=document.getElementById('s3').srcset;">
                </picture>
              </a>
              <a href="https://lionsdigital.pro" class="application-footer-logo-ldp">
               <div class="application-footer-logo-ldp__container">
                 <img src="static/img/ldp-logo_lion-dark.svg" alt="Lions Digital Pro" class="application-footer-logo-ldp__image">
                 <div class="application-footer-logo-ldp__text-container">
                   <div class="application-footer-logo-ldp__text">{{ $t('login.work_tech') }}</div>
                   <img src="static/img/ldp-logo_text-dark.svg" alt="Lions Digital Pro" class="application-footer-logo-ldp__name">
                 </div>
               </div>
              </a>
              <div
                v-if="policyHref"
                class="application-footer-link"
              >
                <a
                  :href="policyHref"
                  class="application-footer-link__link"
                  target="_blank"
                >
                  {{ $t('labels.privacy_policy') }}
                </a>
              </div>
            </div>
          </div>
        </footer>
</template>
<script>
  import config from '@/config'
  import {CONF_CLIENT_SITE_LINK, CONF_CLEINT_LOGO_PREFIX, LANG, PRIVACY_POLICY} from '@/constants'
  import Cookies from 'js-cookie'
  export default {
    data () {
      return {
        clientLink: config(CONF_CLIENT_SITE_LINK),
        clientLogoPrefix: config(CONF_CLEINT_LOGO_PREFIX)
      }
    },
    computed: {
      policyHref () {
        return config(PRIVACY_POLICY) || '';
      },
      lang () {
        return this.$store.state.lang
      },
      logoSrc () {
        return `static/img/logos/${this.clientLogoPrefix}_grey_new_${this.lang}.svg`;
      },
      logoSrcDefault () {
        return `static/img/logos/${this.clientLogoPrefix}_grey_new_en.svg`;
      }
    }
  }

</script>
<style lang="scss">

</style>